export default function stripTags(originalString) {
  return originalString.replace(/(<([^>]+)>)/gi, '');
}
